import BaseService from "./base-service";
import { RequestDto } from "./dto/request/request-dto";

export interface BranchWhiteLabelDTO {
  branchId: number;
  activatedByManager: boolean;
  activatedByAdmin: boolean;
  activatedStartDate: string | null;
  activatedEndDate?: string | null;
  userId: number;
}

export interface BranchWhiteLabelStatusDTO {
  branchId: number;
  isActivated: boolean;
  activatedStartDate?: string;
  activatedEndDate?: string;
  activatedByAdmin?: boolean;
}

export class BranchesWhiteLabelService extends BaseService {
  private resource = "/api/branches-white-label";

  async getWhiteLabelStatus(
    branchId: number,
    onSuccess: (data: BranchWhiteLabelStatusDTO) => void,
    onError: (errorMessage: string) => void
  ) {
    try {
      const reqParams = new RequestDto(`${this.resource}/${branchId}/status`, {});
      await this.doGet<BranchWhiteLabelStatusDTO>(reqParams, onSuccess, onError);
    } catch (error) {
      onError('Error al verificar el estado de la marca blanca');
    }
  }

  async activateWhiteLabel(
    params: BranchWhiteLabelDTO,
    onSuccess: (data: any) => void,
    onError: (errorMessage: string) => void
  ) {
    
    const branchId = Number(params.branchId);

    try {
      // Crear objeto de datos para enviar en el body como JSON
      const requestData = {
        BranchId: params.branchId,
        ActivatedByAdmin: params.activatedByAdmin,
        ActivatedByManager: params.activatedByManager,
        UserId: params.userId,
        ActivatedStartDate: params.activatedStartDate,
        ActivatedEndDate: params.activatedEndDate,
      };
    
      const reqParams = new RequestDto(this.resource, requestData);
      
      await this.doPatch<any>(reqParams, onSuccess, onError);
    } catch (error) {
      onError('Error al activar la marca blanca de la sucursal');
    }
  }
} 